module.exports = __webpack_public_path__ + "img/5-2_06.c4a18954.jpg";